export const LANDING = '/';
export const SIGN_OUT = '/signout';
export const SIGN_IN = '/signin';
export const REGISTER_MULTI_FACTOR = '/registerMultiFactor';
export const HOME = '/home';
export const ACCOUNT = '/account';
export const ADMIN = '/admin';
export const DASHBOARD = '/dashboard';
export const ALERTS = '/alerts';
export const CAMPAIGNS = '/campaigns';
export const REPORTS = '/reports';
export const PROFILE = '/profile';
export const SURVEY = '/SURVEY';
export const AI_ADVISOR = '/ai-advisor';
export const AI_KNOWLEDGE_BASE = '/ai-knowledge-base';
export const DOCS = '/docs';
export const CAMPAIGN_DETAILS = '/campaign';